export const esTemplates = [
    {
        value: "DCF tried to reach you. We'll try again in a few minutes.",
        spanishValue:"DCF intentó comunicarse con usted. Lo intentaremos nuevamente en unos minutos.",
        label: "Retry: DCF tried to reach you. We'll try again in a few minutes.",
    },
    {
        value: "This is DCF. We will be calling you in the next few minutes to talk to you about Whole Family Services and Work Programs for your cash assistance case.",
        spanishValue:"Este es el Departamento de Niños y Familias. Lo llamaremos en los próximos minutos para hablar con usted sobre los Servicios para toda la familia y los Programas de trabajo para su caso de asistencia en efectivo.",
        label: "Whole Family Services: This is DCF. We will be calling you in the next few minutes to talk to you about Whole Family Services and Work Programs for your cash assistance case.",
    },
    {
        value: "This is your DCF Career Navigator, we will be contacting you to complete your appointment in the next 3-5 minutes.",
        spanishValue:"Este es su Navegador de Carreras del DCF, nos comunicaremos con usted para completar su cita en los próximos 3 a 5 minutos.",
        label: "ES Appointment Before Call: This is your DCF Career Navigator, we will be contacting you to complete your appointment in the next 3-5 minutes.",
    },
    {
        value: "This is your DCF Career Navigator, we just attempted to call you for your appointment. We will try again in 3 to 5 minutes.",
        spanishValue:"Este es su Navegador de Carreras del DCF, acabamos de intentar llamarlo para su cita. Lo intentaremos nuevamente en 3 a 5 minutos.",
        label: "ES Appointment After Call: This is your DCF Career Navigator, we just attempted to call you for your appointment. We will try again in 3 to 5 minutes.",
    }
]

